module.exports = "/images/candel.svg?58913c8ddcb898f8ec7b3cc3148446c2";